export const QUEUE_TYPE = {
  AVAILABLE_QUEUE: "available queue",
  HOME_QUEUE: "home queue",
};
